export enum EDataHookDeploymentState {
  DRAFT,
  DEPLOYING,
  DEPLOY_SUCCESS,
  DEPLOY_FAILURE
}
